import React from 'react';

const Projects = () => {
  const projectsData = [
    {
      title: 'LinkSnap — Dockerized Full-Stack Application',
      description: 'Containerized a full-stack React and Node.js application utilizing PostgreSQL. Implemented Docker Compose for orchestration with persisted volumes and network configurations, optimized with multi-stage Dockerfiles and Nginx.',
      tags: ['Docker', 'Docker Compose', 'PostgreSQL', 'Nginx'],
      sourceCode: 'https://github.com/KhalilAhmadPK/linksnap',
      image: '/projects-pics/docker.png'
    },
    {
      title: 'CI/CD Pipeline for Node.js Application',
      description: 'Designed an automated CI/CD pipeline using GitHub Actions for seamless testing and building workflows. Utilized YAML configurations to automate version control processes and ensure high code quality across environments.',
      tags: ['GitHub Actions', 'CI/CD', 'Automation', 'YAML'],
      sourceCode: 'https://github.com/KhalilAhmadPK/ci-node-app',
      image: '/projects-pics/ci-pipeline.png'
    },
    {
      title: 'Kubernetes Deployment for Node.js Application',
      description: 'Orchestrated Docker containers on a Kubernetes cluster using custom manifest files for deployment. Managed scaling, service exposure, and resource limits to ensure high availability and optimal performance of applications.',
      tags: ['Kubernetes', 'Docker', 'Orchestration', 'Scaling'],
      sourceCode: 'https://github.com/KhalilAhmadPK/k8s-node-app',
      image: '/projects-pics/kubernetes.png'
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">My Projects</h2>
        <div className="projects-grid">
          {projectsData.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-img">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="project-content">
                <div className="project-title-box">
                  <h3>{project.title}</h3>
                </div>
                <div className="project-description-box">
                  <p>{project.description}</p>
                </div>
                <div className="project-tags-and-links">
                  <div className="project-tags">
                    {project.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="project-tag">{tag}</span>
                    ))}
                  </div>
                  <div className="project-links">
                    <a href={project.sourceCode} target="_blank" rel="noopener noreferrer" className="project-link">
                      <i className="fab fa-github"></i> Code
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;